"use client";

import React from "react";
import { GridHeader, type GridHeaderProps } from "./grid-header";
import { useLineupSearchSelection } from "./lineup-search.client";
import { withSafeRender } from "../../atoms/safe-render";

/**
 * The Signature grid header under search — GH5, and nothing else. This exists because nothing could
 * pass `searchActive`.
 */

export type SearchableGridHeaderProps = Omit<GridHeaderProps, "searchActive">;

function SearchableGridHeaderImpl(props: SearchableGridHeaderProps) {
  const { isActive } = useLineupSearchSelection();

  return <GridHeader {...props} searchActive={isActive} />;
}
export const SearchableGridHeader = withSafeRender(SearchableGridHeaderImpl, "SearchableGridHeader");

export default SearchableGridHeader;
